import { __spreadArray } from '../../../_virtual/_tslib.js';

function fitIntoSimilarLengthLines(text, containerWidth, fontOpts) {
    return breakTextIntoSimilarWidthLines(text, containerWidth, fontOpts).join('\n');
}
// Everything below exported for testing purposes
function breakTextIntoSimilarWidthLines(text, containerWidth, fontOpts, getTextRenderWidth) {
    if (getTextRenderWidth === void 0) { getTextRenderWidth = measureTextWithCanvas; }
    var totalTextWidth = getTextRenderWidth(text, fontOpts);
    if (totalTextWidth === null) {
        return [text];
    }
    var words = getIndividualWords(text);
    var lineCountByWidth = Math.ceil(totalTextWidth / containerWidth);
    var actualLineCount = Math.min(words.length, lineCountByWidth);
    if (actualLineCount <= 1) {
        return [text];
    }
    var wordGroupings = getPossibleLines(words, actualLineCount);
    var bestWordGrouping = wordGroupings[0];
    var bestWordScore = null;
    var _loop_1 = function (grouping) {
        // Calculate the "score" of the grouping by seeing how far they are, in sum,
        // from being completely equal-length lines
        var lineLengths = grouping.map(function (grouping) { return getTextRenderWidth(grouping, fontOpts); });
        var averageWordLength = lineLengths.reduce(function (sum, wl) { return sum + wl; }, 0) / lineLengths.length;
        var wordScore = lineLengths
            .map(function (wl) { return Math.abs(wl - averageWordLength); })
            .reduce(function (sum, diff) { return sum + diff; }, 0);
        if (bestWordScore === null || wordScore < bestWordScore) {
            bestWordScore = wordScore;
            bestWordGrouping = grouping;
        }
    };
    for (var _i = 0, wordGroupings_1 = wordGroupings; _i < wordGroupings_1.length; _i++) {
        var grouping = wordGroupings_1[_i];
        _loop_1(grouping);
    }
    return bestWordGrouping;
}
function getIndividualWords(text) {
    var wordBuilder = [[]];
    text.split('').forEach(function (letter, index, letters) {
        wordBuilder[wordBuilder.length - 1].push(letter);
        var nextLetter = index < letters.length - 1 ? letters[index + 1] : null;
        var isSeparator = wordSeparator.test(letter);
        var isNextSeparator = nextLetter !== null && wordSeparator.test(nextLetter);
        if (isSeparator && !isNextSeparator) {
            wordBuilder.push([]);
        }
    });
    return wordBuilder.map(function (letters) { return letters.join(''); }).filter(function (word) { return word.length > 0; });
}
function getPossibleLines(words, lineCount) {
    return getWordGroupings(words, lineCount)
        .map(function (lines) { return lines.map(function (line) { return line.trim(); }); });
}
function getWordGroupings(words, ofLength) {
    return getAllWordGroupingsRecursive(words, ofLength)
        .filter(function (group) { return group.length === ofLength; });
}
function getAllWordGroupingsRecursive(words, ofLength, groupings, currentWordIndex) {
    if (groupings === void 0) { groupings = []; }
    if (currentWordIndex === void 0) { currentWordIndex = 0; }
    if (currentWordIndex >= words.length) {
        return groupings;
    }
    var currentWord = words[currentWordIndex];
    if (currentWordIndex === 0) {
        var nextGroupings = __spreadArray(__spreadArray([], groupings, true), [
            [currentWord],
        ], false);
        return getAllWordGroupingsRecursive(words, ofLength, nextGroupings, currentWordIndex + 1);
    }
    else {
        var currGroupings = __spreadArray([], groupings, true);
        var nextGroupings = __spreadArray(__spreadArray([], currGroupings.map(function (group) {
            var copy = __spreadArray([], group, true);
            copy[copy.length - 1] += currentWord;
            return copy;
        }), true), currGroupings.map(function (group) { return __spreadArray(__spreadArray([], group, true), [currentWord], false); }), true);
        return getAllWordGroupingsRecursive(words, ofLength, nextGroupings, currentWordIndex + 1);
    }
}
function measureTextWithCanvas(text, fontOpts) {
    var canvasEl = document.createElement('canvas');
    var ctx = canvasEl.getContext('2d');
    var fontSizeFormatted = typeof fontOpts.fontSize === 'number'
        ? "".concat(fontOpts.fontSize, "px")
        : fontOpts.fontSize;
    ctx.font = "".concat(fontOpts.fontWeight, " ").concat(fontSizeFormatted, "px Rubik, sans-serif");
    return ctx.measureText(text).width;
}
var wordSeparator = /[\s:._-]/;

export { breakTextIntoSimilarWidthLines, fitIntoSimilarLengthLines, getIndividualWords, getPossibleLines };
